import {
    SET_EXPERIENCES,
    ADD_EXPERIENCE,
    UPDATE_EXPERIENCE,
    DELETE_EXPERIENCE,
    SET_EXPERIENCE_REACTIONS,
    ADD_EXPERIENCE_COMMENT,
    DELETE_EXPERIENCE_COMMENT,
    SET_EXPERIENCE_LOADING
} from '../actions/experiences';

const initialState = {
    experiences: [],
    loading: false,
    error: null
};

export default function experiencesReducer(state = initialState, action) {
    switch (action.type) {
        case SET_EXPERIENCES:
            return {
                ...state,
                experiences: action.payload,
                error: null
            };

        case ADD_EXPERIENCE:
            return {
                ...state,
                experiences: [action.payload, ...state.experiences]
            };

        case UPDATE_EXPERIENCE:
            return {
                ...state,
                experiences: state.experiences.map(exp =>
                    exp.id === action.payload.id ? action.payload : exp
                )
            };

        case DELETE_EXPERIENCE:
            return {
                ...state,
                experiences: state.experiences.filter(exp => exp.id !== action.payload)
            };

        case SET_EXPERIENCE_REACTIONS:
            return {
                ...state,
                experiences: state.experiences.map(exp =>
                    exp.id === action.payload.experienceId
                        ? { ...exp, reactions: action.payload.reactions }
                        : exp
                )
            };

        case ADD_EXPERIENCE_COMMENT:
            return {
                ...state,
                experiences: state.experiences.map(exp =>
                    exp.id === action.payload.experienceId
                        ? {
                            ...exp,
                            comments: [...(exp.comments || []), action.payload.comment]
                        }
                        : exp
                )
            };

        case DELETE_EXPERIENCE_COMMENT:
            return {
                ...state,
                experiences: state.experiences.map(exp =>
                    exp.id === action.payload.experienceId
                        ? {
                            ...exp,
                            comments: exp.comments.filter(comment => 
                                comment.id !== action.payload.commentId
                            )
                        }
                        : exp
                )
            };

        case SET_EXPERIENCE_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        default:
            return state;
    }
}